module.exports = require("@gauzy/plugin-integration-jira");